// src/hooks/useSEO.js
// Hook que integra React Helmet com pageMetadata.js
// Uso: const useSEO = () => { useSEO(); } no topo de qualquer página

import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import pageMetadata from '../config/seo/pageMetadata';
import seoConfig from '../config/seo/seoConfig';

const useSEO = () => {
  const location = useLocation();
  const metadata = pageMetadata[location.pathname];

  if (!metadata) {
    console.warn(`SEO metadata not found for path: ${location.pathname}`);
  }

  return (
    <Helmet>
      <title>{metadata?.title || 'Verde Musgo Natural'}</title>
      <meta name="description" content={metadata?.description || seoConfig.company.shortDescription} />
      <meta name="keywords" content={metadata?.keywords} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="language" content="Portuguese" />

      {/* Open Graph */}
      <meta property="og:type" content={metadata?.ogType || 'website'} />
      <meta property="og:title" content={metadata?.title} />
      <meta property="og:description" content={metadata?.description} />
      <meta property="og:image" content={metadata?.ogImage} />
      <meta property="og:url" content={metadata?.canonical} />
      <meta property="og:site_name" content={seoConfig.company.name} />
      <meta property="og:locale" content="pt_BR" />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
      <meta name="geo.region" content="BR-SP" />
      <meta name="geo.placename" content="Embu-Guaçu" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metadata?.title} />
      <meta name="twitter:description" content={metadata?.description} />
      <meta name="twitter:image" content={metadata?.ogImage} />

      {/* Canonical */}
      <link rel="canonical" href={metadata?.canonical} />

      {/* Icons */}
      <link rel="icon" href={seoConfig.company.favicon} />
      <link rel="apple-touch-icon" href={seoConfig.company.logo} />
    </Helmet>
  );
};

export default useSEO;
